import { render, staticRenderFns } from "./ThemeBackground.vue?vue&type=template&id=7f2f33b2&scoped=true&"
import script from "./ThemeBackground.vue?vue&type=script&lang=js&"
export * from "./ThemeBackground.vue?vue&type=script&lang=js&"
import style0 from "./ThemeBackground.vue?vue&type=style&index=0&id=7f2f33b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2f33b2",
  null
  
)

export default component.exports